import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './ClientReviews.css';

const reviews = [
  {
    name: "Rajesh Kumar",
    location: "K.K. Nagar, Madurai",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&h=150&q=80",
    review: "VARK Builders delivered my luxury villa on time with exceptional structural quality. Their engineering team's attention to detail is commendable.",
    rating: 5
  },
  {
    name: "Anitha Pandian",
    location: "Iyer Bungalow, Madurai",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&h=150&q=80",
    review: "Best civil construction company in Madurai! They transformed our blueprint into a gorgeous reality. The modern house layout is perfect.",
    rating: 5
  },
  {
    name: "Senthil Nathan",
    location: "Anna Nagar, Madurai",
    photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&h=150&q=80",
    review: "Highly professional and extremely transparent. No hidden charges. They are truly reliable building promoters in Tamil Nadu.",
    rating: 5
  },
  {
    name: "Meenakshi Sundaram",
    location: "Bypass Road, Madurai",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=150&h=150&q=80",
    review: "The renovation work they executed for our commercial complex was outstanding. On-time delivery and strictly within the budget limits.",
    rating: 5
  },
  {
    name: "Dr. Vikram Ramasamy",
    location: "K.P. Nagar, Coimbatore",
    photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&h=150&q=80",
    review: "Superb experience working with VARK Builders. Their turnkey construction package is extremely convenient and hassle-free for busy professionals.",
    rating: 5
  },
  {
    name: "Kavitha Selvaraj",
    location: "Velachery, Chennai",
    photo: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&h=150&q=80",
    review: "Their interior design work was phenomenal! Modifying our modular kitchen and wardrobe layout has elevated the aesthetics of our entire home.",
    rating: 5
  }
];

const ClientReviews = () => {
  return (
    <section className="reviews-section" id="reviews">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="subtitle">Testimonials</span>
          <h2>What Our <span>Clients Say</span></h2>
          <p>Read experiences from our satisfied homeowners and business partners.</p>
        </div>

        <Swiper
          modules={[Pagination, Autoplay, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          navigation={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="reviews-swiper"
        >
          {reviews.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="review-card">
                <div className="quote-icon"><FaQuoteLeft /></div>
                <div className="rating">
                  {[...Array(item.rating)].map((_, i) => <FaStar key={i} />)}
                </div>
                <p className="review-text">"{item.review}"</p>
                <div className="client-info-wrapper">
                  <img src={item.photo} alt={item.name} className="client-avatar" />
                  <div className="client-details">
                    <h4>{item.name}</h4>
                    <span>{item.location}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ClientReviews;
